import { render, staticRenderFns } from "./tablaCaracteristicas.vue?vue&type=template&id=23d58370&scoped=true&"
import script from "./tablaCaracteristicas.vue?vue&type=script&lang=js&"
export * from "./tablaCaracteristicas.vue?vue&type=script&lang=js&"
import style0 from "./tablaCaracteristicas.vue?vue&type=style&index=0&id=23d58370&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d58370",
  null
  
)

export default component.exports